import { render, staticRenderFns } from "./SyntheseV1Tab.vue?vue&type=template&id=71c67d61&scoped=true"
import script from "./SyntheseV1Tab.vue?vue&type=script&lang=js"
export * from "./SyntheseV1Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c67d61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c67d61')) {
      api.createRecord('71c67d61', component.options)
    } else {
      api.reload('71c67d61', component.options)
    }
    module.hot.accept("./SyntheseV1Tab.vue?vue&type=template&id=71c67d61&scoped=true", function () {
      api.rerender('71c67d61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/campaign/Evaluate/partials/tabs/SyntheseV1Tab.vue"
export default component.exports